export enum ProjectLifecycle {
  IN_PROGRESS = 'in-progress',
  RELEASED = 'released',
  DEPRECATED = 'deprecated',
  DECOMMISSIONED = 'decommissioned',
}

export enum ProjectRiskRating {
  LOW = 'low',
  MEDIUM = 'medium',
  HIGH = 'high',
  VERY_HIGH = 'very high',
}

export enum ProjectConfidentiality {
  C0 = 'C0',
  C1 = 'C1',
  C2 = 'C2',
  C3 = 'C3',
}

export enum ImpactLevel {
  LOW = 'low',
  MEDIUM = 'medium',
  HIGH = 'high',
}

export enum FullImpactLevel {
  LOW = 'low',
  MEDIUM = 'medium',
  HIGH = 'high',
  VERY_HIGH = 'very high',
}

export enum ProjectRegion {
  AFRICA = 'AFRICA',
  AMER = 'AMER',
  ASIA = 'ASIA',
  EMEA = 'EMEA',
  NONE = 'NONE',
}

export enum Origin {
  EUDA = 'euda',
  LAMBDA = 'lambda',
  DATA_SET = 'dataset',
  MAXX = 'maxx',
  DAF = 'daf',
  SG_WORKFLOW = 'sgworkflow',
  ALTERYX = 'alteryx',
  POWER_PLATFORM = 'powerplatform',
  APP_STUDIO = 'appstudio',
  POWER_BI = 'powerbi',
  FARMS = 'farms',
  TABLEAU = 'tableau',
  UNMANAGED = 'unmanaged',
  PROJECT = 'project',
  PROMPT = 'prompt',
}

export type OriginType =
  | 'euda'
  | 'lambda'
  | 'daf'
  | 'sgworkflow'
  | 'alteryx'
  | 'dataset'
  | 'maxx'
  | 'appstudio'
  | 'powerplatform'
  | 'powerbi'
  | 'farms'
  | 'tableau'
  | 'unmanaged'
  | 'project'
  | 'prompt'
  | 'all';

export enum Exposition {
  INTERNAL = 'internal',
  EXTERNAL = 'external',
}

export enum IODataIntegrity {
  NONE = 'none',
  TACTICAL = 'tactical',
  GOLDEN_SOURCE = 'golden source',
}

export enum Anomaly {
  MISSING_CERTICATION = 'missingCertification',
  MISSING_VALIDATION = 'missingValidation',
  NO_ACTIVE_OWNER = 'noActiveOwner',
  NO_ACTIVE_CITIZEN_DEVELOPER = 'noActiveCitizenDeveloper',
  RISK_RATING = 'riskRating',
}

export enum ResourceType {
  EUC = 'euc',
  PROMPT_BUSINESS_PROCESS = 'promptBusinessProcess',
  PROMPT_NOT_BUSINESS_PROCESS = 'promptNotBusinessProcess',
  EUC_COMPONENT = 'component',
  APPLICATION = 'application',
  NOT_BUSINESS_PROCESS = 'notBusinessProcess',
  DATA = 'data',
}

export enum StandardRef {
  GROUPv1 = 'GROUPv1',
  GROUPv2 = 'GROUPv2',
}

export enum Distribution {
  MANUALLY_SENT = 'Manually Sent',
  AUTOMATICALLY_SENT = 'Automatically Sent',
}

export enum ReportRecipient {
  REGULATOR = 'Regulator',
  CLIENT = 'Client',
  OTHERS = 'Others',
  SENIOR_MANAGEMENT = 'Senior Management',
}

export enum UserRoles {
  CITIZEN_DEVELOPER = 'citizenDevelopers',
  OWNER = 'owner',
  OWNER_MANAGER = 'ownerManager',
  MANAGER_BACKUPS = 'managerBackups',
}

export enum eucExecution {
  MANAGED_PLATFORM = 'managed_platform',
  LOCAL_COMPUTER = 'local_computer',
}

export enum HumanReviewLevel {
  FULL_REVIEW = 'full_review',
  LIMITED_REVIEW = 'limited_review',
  NO_REVIEW = 'no_review',
}

export enum MonitoringTestingLevel {
  NONE = 'none',
  MANUAL = 'manual',
  AUTOMATED = 'automated',
}

export enum UnitCount {
  TWO_OR_LESS = 'two_or_less',
  THREE = 'three',
  FOUR_OR_MORE = 'four_or_more',
}
